const CHAVE_TOKEN = 'premiacao.token';

export function lerToken(): string | null {
  return localStorage.getItem(CHAVE_TOKEN);
}

export function guardarToken(token: string): void {
  localStorage.setItem(CHAVE_TOKEN, token);
}

export function limparToken(): void {
  localStorage.removeItem(CHAVE_TOKEN);
}

export class ErroApi extends Error {
  readonly status: number;
  /** Dado extra que o servidor manda para a tela poder oferecer uma saída. */
  readonly detalhe: unknown;

  constructor(status: number, mensagem: string, detalhe?: unknown) {
    super(mensagem);
    this.name = 'ErroApi';
    this.status = status;
    this.detalhe = detalhe;
  }
}

/**
 * Cliente da API. Em produção o front e o servidor saem do mesmo container,
 * então o caminho relativo basta; em desenvolvimento o Vite repassa /api.
 *
 * Toda mensagem de erro que chega do servidor já está escrita para o usuário
 * final, então é ela que sobe — nada de "erro 409".
 */
export async function api<T>(
  caminho: string,
  opcoes: { metodo?: string; corpo?: unknown } = {},
): Promise<T> {
  const token = lerToken();
  const resposta = await fetch(`/api${caminho}`, {
    method: opcoes.metodo ?? 'GET',
    headers: {
      ...(opcoes.corpo === undefined ? {} : { 'Content-Type': 'application/json' }),
      ...(token === null ? {} : { Authorization: `Bearer ${token}` }),
    },
    body: opcoes.corpo === undefined ? undefined : JSON.stringify(opcoes.corpo),
  });

  if (resposta.status === 204) return undefined as T;

  let dados: unknown = null;
  try {
    dados = await resposta.json();
  } catch {
    dados = null;
  }

  if (!resposta.ok) {
    const mensagem =
      (dados as { erro?: string } | null)?.erro ??
      `O servidor respondeu ${resposta.status}. Tente novamente em alguns instantes.`;
    // Sessão expirada: limpar o token faz o app voltar para o login sozinho.
    if (resposta.status === 401) limparToken();
    throw new ErroApi(resposta.status, mensagem, (dados as { detalhe?: unknown } | null)?.detalhe);
  }

  return dados as T;
}
